import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from "@angular/core";
import {
  IonContent,
  LoadingController,
  Platform,
} from "@ionic/angular";
import {
  FormGroup,
  FormControl,
  Validators,
  AbstractControl,
} from "@angular/forms";
import { PopoverController } from "@ionic/angular";
import { isUndefined } from "../../../../services/codeUtils";
import { DepositMainLabels } from "../../../cashier/deposit/cashier-models/interfaces";
import { CreditCardModel } from "../../../cashier/deposit/cashier-models/models";
import { WithdrawalBaseComponent } from "../withdrawal-base/withdrawal-base.component";
import { AccountBalanceService } from "src/app/services/balance/account-balance.service";
import { AppLinksService } from "src/app/services/applinks/app-links.service";
import { DEPOSIT_PATTERN } from "src/app/services/customFormValidators";
import { ConfigService } from "src/app/services/config/config.service";
import { UtilsService } from "src/app/services/utils/utils.service";
import { CustomerModel } from "src/app/models/customer-model";
import { UserSessionService } from "src/app/services/user-session/user-session.service";
import { SuccessMessageService } from "src/app/services/message-provider/success-message.service";
import { ConfigurationService } from "src/app/services/configuration/configuration.service";
import { CashierService } from "src/app/services/cashier/cashier.service";
import { CashierContentService } from "src/app/services/cashier/cashier-content.service";
import { AddressService } from "src/app/services/address/address.service";
import { WithdrawalService } from "src/app/services/cashier/withdrawal.service";
import { Navigator } from "src/app/services/routing/navigator";
import { EventsService } from "src/app/services/event/event.service";
import { BalanceModel } from "src/app/models/balance-model";
import { first } from "rxjs/operators";

//@IonicPage()
@Component({
  selector: "withdrawal-fastaccess",
  templateUrl: "withdrawal-fastaccess.html",
})
export class WithdrawalFastAccessComponent
  extends WithdrawalBaseComponent
  implements OnInit
{
  @ViewChild("Content") content: IonContent;
  @Input() bonusCode: string;
  @Input() navigateBackPage: string;

  private error = null;

  public defaultAmounts: any = [];
  public vendorLogoUrl: string = "";
  public labels: DepositMainLabels;

  // Form Abstract Controls
  private withdrawalForm: FormGroup;
  private amount: AbstractControl;
  private cardNumber: AbstractControl;
  private cardList: AbstractControl;
  private cardExpiryGroup: AbstractControl;
  private country: AbstractControl;
  private countryInfoGroup: AbstractControl;
  private streetGroup: AbstractControl;
  private paymentTypeCode: AbstractControl;
  private selectedMonth: string;
  private selectedYear: string;

  public selectedCard: string;

  //Flags
  public isExistingCard: boolean;
  public isExistingCardList: boolean;
  public showCVV: boolean = false;
  public buttonDisabled: boolean = false;
  public showAddressFields: boolean = false;
  public enterCounts = 0;
  enterPressed: boolean;

  private cardExpMonths: object;
  private cardExpYears: any[];
  private cards: any = [];

  public maxNumCards;

  private customer;
  public countries;
  public countriesMobile;
  public provinces;
  public selectedCountry: string = "";
  public selectedProvince: string = "";
  private paymentType: any = [];
  private defaultAmount: any = [];
  public minAmount;
  public loading;
  public environmentName = "";
  public fastAccessPaymentTypeCodes;
  public holdFastAccessPaymentArray: Array<any> = [];
  public accountBalances: BalanceModel;

  //Constructor Start

  constructor(
    protected cashierProvider: CashierService,
    private config: ConfigService,
    public configProvider: ConfigurationService,
    private contentProvider: CashierContentService,
    protected successMessageProvider: SuccessMessageService,
    protected userSession: UserSessionService,
    protected utils: UtilsService,
    protected popoverCtrl: PopoverController,
    private cd: ChangeDetectorRef,
    protected events: EventsService,
    protected platform: Platform,
    protected appLinks: AppLinksService,
    private loadingController: LoadingController,
    private balanceProvider: AccountBalanceService,
    private addressService: AddressService,
    private withDrawService: WithdrawalService,
    public navigator: Navigator
  ) {
    super();
    this.labels = new CreditCardModel();

    this.error = null;

    this.userSession.getCustomer().subscribe(
      (customer) => {
        if (customer) {
          this.customer = customer;
        } else {
          this.customer = new CustomerModel();
        }
      },
      (error) => {
        console.log(error);
      }
    );
    this.successMessageProvider.clearMessage();
    this.showLoading();
  }

  async showLoading() {
    this.loading = await this.loadingController.create({
      message: "Loading Card Payouts...",
    });

    this.loading.present();
    setTimeout(() => this.loading.dismiss(), 650);
  }
  //ngOnInit Start

  ngOnInit() {
    this.fastAccessPaymentTypeCodes =
      this.config.getConfig().FEATURE_FASTACCESS_PAYMENT_CODE || "FAF";
    if (this.fastAccessPaymentTypeCodes.includes(",")) {
      this.holdFastAccessPaymentArray =
        this.fastAccessPaymentTypeCodes.split(",");
    } else {
      let value = this.fastAccessPaymentTypeCodes;
      let tempArray = [];
      tempArray.push(value);
      this.holdFastAccessPaymentArray = tempArray;
    }

    // Deposit form Intialization
    this.withdrawalForm = new FormGroup({
      amount: new FormControl(
        {
          value: "",
          disabled: false,
        },
        {
          validators: [
            Validators.pattern(DEPOSIT_PATTERN),
            Validators.required,
          ],
          updateOn: "change",
        }
      ),
      cardList: new FormControl(
        { value: "", disabled: false },
        { validators: [Validators.required] }
      ),
      paymentTypeCode: new FormControl({ value: "", disabled: false }, [
        Validators.required,
      ]),
    });

    // Getting Form Data
    this.amount = this.withdrawalForm.get("amount");
    this.cardNumber = this.withdrawalForm.get("cardNumber");
    this.paymentTypeCode = this.withdrawalForm.get("paymentTypeCode");
    this.onGetAccounts(false); // Getting Existimg Cards
    this.onGetBalance();
    this.isExistingCardList = false;
  }

  //ngOnInit Ends

  ngAfterViewInit() {
    this.contentProvider
      .getPageConfig("faf")
      .then((response: DepositMainLabels) => {
        this.labels = response;
      });
    //Webservice Calls to get Credit Card Data

    this.cashierProvider.getActivePaymentTypes("CREDIT").subscribe(
      (response: any) => {
        if (response.result) {
          this.paymentType = response.payload;
          this.minAmount = this.paymentType[0].min;
          this.onPaymentType(0); // Intilaizing in Default Amounts in the beginning
        }
      },
      (error) => {}
    );

    //To get the logo for credit/visa
    this.cashierProvider
      .getActiveTypesCategories({ include_types: true })
      .subscribe(
        (response: any) => {
          if (response.result) {
            let vendors = response.payload;
            let filterData = vendors.filter((x) => x.code == "CREDIT");
            this.vendorLogoUrl = this.utils.getCDNAsset(
              "deposit/" + filterData[0]?.image_url
            );
          }
        },
        (error) => {}
      );
    this.cd.detectChanges();
  }

  onGetBalance() {
    this.balanceProvider
      .getBalance()
      .pipe(first())
      .subscribe((balance: BalanceModel) => {
        if (balance) {
          this.accountBalances = balance;
        }
      });
    this.error = null;
  }

  public getPaymentImage(paymentTypeCode: string): string {
    const paymentTypeVal = this.paymentType.filter((pymnt) => {
      return pymnt.code == paymentTypeCode;
    });
    let imageUrl: string;
    imageUrl = `url(${this.utils.getDepositCDNAAsset(
      paymentTypeVal[0]?.image_url
    )})`;
    return imageUrl;
  }

  // To get Existing Saved Credit Cards

  onGetAccounts(justRefreshList: boolean) {
    this.cards = [];
    this.cashierProvider.callListAccounts().subscribe(
      (response: any) => {
        if (response && !!response.result) {
          var tempCards: any = response.payload;
          let i = 0;
          for (let index in tempCards) {
            for (let i = 0; i < this.holdFastAccessPaymentArray.length; i++) {
              if (
                tempCards[index].paymentTypeCode ==
                this.holdFastAccessPaymentArray[i]
              ) {
                tempCards[index].id = i;
                i++;
                this.cards.push(tempCards[index]);
              }
            }
          }
          if (!!this.cards[0]) {
            if (this.cards.length === 1) {
              //Reset card id to match index logic for UI to pass the value properly
              if (this.cards[0].id == 1) {
                this.cards[0].id = 0;
                this.selectedCard = this.cards[0].id;
                this.isExistingCardList = true;
                console.log(
                  "User has only one account and that account has index set for 1. So, reset index to 0."
                );
              } else {
                this.selectedCard = this.cards[0].id;
                this.isExistingCardList = true;
                console.log(
                  "User has only one account and that account has index set for 0. So, no need to reset the index."
                );
              }
            } else {
              this.selectedCard = this.cards[0].id;
              this.isExistingCardList = true;
              console.log(
                "User has more than one FAF accounts. No issue with index for this case."
              );
            }
          }

          if (justRefreshList == false) {
            this.onLoadElement();
          }
        } else {
          this.onPaymentType(0);
        }
      },
      (error) => {
        this.error = error;
      }
    );
  }

  // Submit Credit Card Form

  onSubmit() {
    this.buttonDisabled = true;
    // Handling multiple enter clicks on mobile
    this.checkEnterSubmission();
  }

  checkEnterSubmission() {
    if (this.enterPressed === true) {
      if (this.enterCounts == 1) {
        setTimeout(() => {
          if (this.isExistingCard == true) {
            this.onWithdraw(null);
          } else {
            //this.onAddCard();
          }
        }, 200);
      }
      this.buttonDisabled = false;
      this.enterPressed = false;
    } else {
      setTimeout(() => {
        if (this.isExistingCard == true) {
          this.onWithdraw(null);
        } else {
          //this.onAddCard();
        }
      }, 200);
    }
  }

  onWithdraw(customerAccountID: string) {
    this.buttonDisabled = true;
    this.error = null;
    this.successMessageProvider.clearMessage();

    let withdrawalFormObj: any = this.withdrawalForm.value;

    if (this.bonusCode != "") {
      withdrawalFormObj.bonusCode = this.bonusCode;
    }

    withdrawalFormObj.amount = this.withdrawalForm.get("amount").value;
    withdrawalFormObj.customerAccountID = customerAccountID;
    withdrawalFormObj.currency_code =
      this.cashierProvider.customer.preferredCurrency.currencyCode;
    //withdrawalFormObj.cardExpMonth = this.cardExpiryGroup.get('cardExpMonth').value;
    //withdrawalFormObj.cardExpYear = this.cardExpiryGroup.get('cardExpYear').value;
    withdrawalFormObj.payment_type_code = "FAF";

    if (this.isExistingCard == true) {
      let cardList: AbstractControl = this.withdrawalForm.get("cardList");
      let index: number = cardList.value;
      withdrawalFormObj.customerAccountID = this.cards[index].customerAccountID;
    } else {
      withdrawalFormObj.customerAccountID = customerAccountID;
    }
    this.withDrawService.callWithdraw(this.withdrawalForm.value).subscribe(
      (response: any) => {
        //    this.logger.log("callWithdraw response = ", response);
        if (response && !!response.result) {
          // send the withdrawal event
          let depositEventData = {
            customerId: this.cashierProvider.customer.customerId,
            amount: this.withdrawalForm.get("amount").value,
          };
          setTimeout(
            () => this.events.publish("event:withdraw", depositEventData),
            2000
          );

          this.amount.setValue("");
          this.amount.markAsPristine();

          this.successMessageProvider.setMessage(
            "Your withdrawal request has been received."
          );

          this.balanceProvider.updateBalance();

          this.content.scrollToTop();
          setTimeout(() => {
            this.successMessageProvider.clearMessage();
            this.buttonDisabled = false;
          }, 5000);
        }
      },
      (error) => {
        // handle all deposit errors in base
        this.error = this.handleError(error);
        //  this.logger.log("callWithdraw error = ", error);
        this.content.scrollToTop();
        setTimeout(() => {
          this.buttonDisabled = false;
        }, 1000);
      }
    );

    this.error = null;
  }

  // Switching Cases

  onLoadElement() {
    if (this.cards.length > 0) {
      this.isExistingCard = true;
      this.withdrawalForm.removeControl("cardNumber");
      this.withdrawalForm.removeControl("paymentTypeCode");
      this.onRadioChecked(0);
    } else {
      this.isExistingCard = false;
    }

  }

  onRadioChecked(index: number) {
    this.isExistingCard = true;
  }

  onPaymentType(data) {
    let i: number = 0;

    this.defaultAmounts = [];

    while (i < 11) {
      if (
        typeof this.paymentType[data]["default_amt_" + (i + 1)] !== "undefined"
      ) {
        this.defaultAmounts.push(
          this.paymentType[data]["default_amt_" + (i + 1)]
        );
      } else {
        break;
      }
      i++;
    }
  }

  // Back Button Logic
  onBack = () => {
    if (!!this.navigateBackPage) {
      if (this.navigateBackPage == "default") {
        //Navigator.toLobby();
        this.navigator.navigateTo("CashierMainPage", { multipleModals: true });
      } else {
        this.navigator.navigateTo(this.navigateBackPage);
      }
    } else {
      this.navigator.back();
    }
  };
}
